import React from 'react';
import { Outlet, OutletProps } from 'react-router-dom';
import { Spin } from 'antd';
import { PageContainer } from '@fregata/shared';
import ErrorBoundary from 'ErrorBoundary';

const OutletLayout = (props: OutletProps) => {
  return (
    <ErrorBoundary>
      <React.Suspense
        fallback={
          <PageContainer isBody>
            <Spin />
          </PageContainer>
        }
      >
        <Outlet {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
};

export default OutletLayout;
